module.exports = __webpack_public_path__ + "static/img/057_TO8_1605.6debe6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/057_TO8_1605.jpg
// module id = bjVf
// module chunks = 0